import { render, staticRenderFns } from "./CollectionInfo.vue?vue&type=template&id=617b84bc&scoped=true"
import script from "./CollectionInfo.vue?vue&type=script&lang=js"
export * from "./CollectionInfo.vue?vue&type=script&lang=js"
import style0 from "./CollectionInfo.vue?vue&type=style&index=0&id=617b84bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b84bc",
  null
  
)

export default component.exports